import React from 'react';
import { List } from 'immutable';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  FadeWrapper,
  LandingPageHero,
} from '../../../components';

const ALLOWED_WIDE_PARAGRAPHS = [
  'video',
  'accordeon',
  'link_list',
];

import './style.scss';

const NodeLandingPage = ({ entity }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'value'], '');
  const image = entity.getIn(['field_media_item', 0]);
  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);

  return (
    <article className="NodeLandingPage">
      <Container>
        <LandingPageHero
          title={title}
          body={body}
          image={image}
          link={link}
          linkTitle={linkTitle}
        />
      </Container>

      {/* Start of paragraphs */}
      <FadeWrapper delay={300}>
        {entity.get('field_paragraphs') ? (
          <div className="node--page--paragraphs-wrapper">
            {entity.get('field_paragraphs', List()).map((paragraph) => {
              const id = paragraph.get('target_id');
              const paragraphType = paragraph.getIn(['entity', 'type', 0, 'target_id']);
              return (
                <FadeWrapper key={`paragraph:${id}`}>
                  <Paragraph
                    key={`paragraph:${id}`}
                    id={id}
                    entity={paragraph.get('entity')}
                    wide={ALLOWED_WIDE_PARAGRAPHS.includes(paragraphType)}
                  />
                </FadeWrapper>
              );
            })}
          </div>
        ) : null}
        {/* End of paragraphs */}
      </FadeWrapper>

    </article>
  );
};

export default NodeLandingPage;
